export const unescapeQuotes = inputString => {
  if (typeof inputString !== 'string') return inputString;
  return inputString.replace(/&quot;/g, '"');
};

export const unescapeQuotesInObject = object => {
  const newObject = {};
  const keys = Object.keys(object);
  keys.forEach(key => {
    newObject[key] = unescapeQuotes(object[key]);
  });

  return newObject;
};

export const removeStrValue = (str) => {
  const regEx = /[^\d\+]/g;
  return str.replace(regEx, '');
};

export const addValue = (str, index, value) => {
  if (index > 0) {
    return str.substring(0, index) + value + str.substr(index);
  }

  return value + str;
};